import { render } from "./AddInvoicePaidItem.vue?vue&type=template&id=0fe2b4dc&scoped=true"
import script from "./AddInvoicePaidItem.vue?vue&type=script&lang=js"
export * from "./AddInvoicePaidItem.vue?vue&type=script&lang=js"

import "./AddInvoicePaidItem.vue?vue&type=style&index=0&id=0fe2b4dc&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe2b4dc"]])

export default __exports__